import {CA} from '../../../../shared/scripts/analytics/Analytics'
import {Sound} from '../../../../shared/scripts/Sound'
import {setElementOnClick} from '../../../../shared/scripts/ui_utils/DomUtils'
import {UIManager} from '../UIManager'
import {Scene} from '../UISceneTypes'
import {MatchmakingCardCategory} from '../../../../shared/scripts/ui_html/home_page/UIModeSelectorController'
import {AnalyticEventType, AnalyticEventCategory} from '../../../../../shared/entity_datas/EntityDatas'

export class UILandingPageController {
    private readonly uiManager: UIManager
    private readonly landingPageContainerDiv: HTMLDivElement
    readonly playWithFriendsCTA: HTMLLinkElement
    private readonly playOnlineCTA: HTMLLinkElement
    private readonly playOnWebCTA: HTMLLinkElement
    private readonly appBannerButton: HTMLButtonElement

    constructor(uiManager: UIManager) {
        this.uiManager = uiManager

        this.landingPageContainerDiv = document.getElementById('scene_landing_page_container') as HTMLDivElement
        this.playWithFriendsCTA = document.getElementById('landingpage_cta_playwithfriends') as HTMLLinkElement
        this.playOnlineCTA = document.getElementById('landingpage_cta_playonline') as HTMLLinkElement
        this.playOnWebCTA = document.getElementById('landingpage_cta_playonweb') as HTMLLinkElement
        this.appBannerButton = document.getElementById('app_banner_open_app_button') as HTMLButtonElement

        setElementOnClick(this.playWithFriendsCTA, () => this.clickPlayWithFriendsCTA())
        setElementOnClick(this.playOnlineCTA, () => this.clickPlayOnlineCTA())
        setElementOnClick(this.playOnWebCTA, () => this.clickPlayOnlineCTA())
        setElementOnClick(this.appBannerButton, () => void this.clickAppBannerButton())
    }

    private clickPlayWithFriendsCTA() {
        Sound.playSound(Sound.SoundType.Click)
        void CA.sendAnalyticEvent({
            type: AnalyticEventType.ClickedLandingPagePlayWithFriends,
            category: AnalyticEventCategory.LandingPage,
        })
        this.uiManager.sceneController.loadScene(Scene.Lobby)
    }

    private clickPlayOnlineCTA() {
        Sound.playSound(Sound.SoundType.Click)
        void CA.sendAnalyticEvent({
            type: AnalyticEventType.ClickedLandingPageExploreModes,
            category: AnalyticEventCategory.LandingPage,
        })
        this.uiManager.modeSelector.selectTab(MatchmakingCardCategory.Bots)
        this.uiManager.sceneController.loadScene(Scene.MainPage)
    }

    // eslint-disable-next-line class-methods-use-this
    private async clickAppBannerButton() {
        Sound.playSound(Sound.SoundType.Click)
        await CA.sendAnalyticEvent({
            type: AnalyticEventType.ClickedLandingPageOpenApp,
            category: AnalyticEventCategory.LandingPage,
        })

        // Must be the colonist.io URL, otherwise Universal Deeplink will not be triggered
        window.location.href = 'https://colonist.io/open-app'
    }

    hide() {
        if(this.landingPageContainerDiv != undefined) this.landingPageContainerDiv.style.display = 'none'
    }

    show() {
        if(this.landingPageContainerDiv != undefined) this.landingPageContainerDiv.style.display = 'flex'
    }
}
